<template>
  <div>
    <div class="md-layout-item md-size-25 md-small-size-100">
      <validation-field :validations="validations.recipients" name="recipient">
        <label>{{ $t("communication.choose_recipient") }}</label>
        <md-select
          name="recipient"
          v-model="data.recipients"
          id="recipient"
          required
        >
          <md-option value="Student">{{ $t("common.student") }}</md-option>
          <md-option value="Family">{{ $t("common.family") }}</md-option>
          <md-option value="Teacher">{{ $t("common.teacher") }}</md-option>
          <md-option value="Counselor">{{ $t("common.counselor") }}</md-option>
        </md-select>
        <span
          style="top:40px"
          class="md-error"
          v-if="serverValidations.recipients"
          >{{ serverValidations.recipients }}</span
        >
      </validation-field>
    </div>
    <div v-if="data.recipients === 'Student'">
      <student-option :hasCheckBox="hasCheckBox" :data="data"></student-option>
    </div>
    <div v-if="data.recipients === 'Family'">
      <family-option :data="data"></family-option>
    </div>
    <div v-if="data.recipients === 'Teacher'">
      <teacher-option :data="data"></teacher-option>
    </div>
    <div v-if="data.recipients === 'Counselor'">
      <counselor-option :data="data"></counselor-option>
    </div>
  </div>
</template>
<script>
import StudentOption from "./Student";
import FamilyOption from "./Family";
import TeacherOption from "./Teacher";
import CounselorOption from "./Counselor";
export default {
  name: "FilterOptions",
  props: ["data", "validations", "serverValidations", "hasCheckBox"],
  components: { CounselorOption, TeacherOption, FamilyOption, StudentOption },
  data() {
    return {
      target: "Student"
    };
  },
  watch: {
    "data.recipients": function() {
      this.data.filter_by = null;
    }
  }
};
</script>
